<template>
  <div class="Chat">
    <v-row style="margin: 0; padding: 0; margin-top: 0">
      <v-col class="Chat__mainContainer">
        <v-card flat class="Chat__header">
          <v-card-text class="d-flex">
            <v-btn icon small @click.stop="goToStartPage">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>

            <v-divider vertical class="mx-2"></v-divider>

            <v-btn
              text
              small
              @click.stop="selectSession(null)"
              class="text-none"
            >
              <v-avatar
                size="24"
                class="mr-2"
                style="background-color: rgba(192, 192, 192, 0.3)"
              >
                <v-icon>mdi-plus</v-icon>
              </v-avatar>
              New Session
            </v-btn>
            <v-spacer></v-spacer>

            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn text small v-on="on" class="text-none">
                  <v-icon left>mdi-account-group-outline</v-icon>
                  {{ chatWorkspace?.name || 'Agent not Selected' }}
                  <v-icon right>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-subheader>Agents</v-subheader>
                <v-list-item @click="changeWorkspace(null)">
                  <v-list-item-title class="primary--text"
                    >None</v-list-item-title
                  >
                </v-list-item>
                <v-list-item
                  v-for="(item, i) in workspaces"
                  :key="i"
                  @click="changeWorkspace(item)"
                >
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-divider vertical class="mx-2"></v-divider>

            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  text
                  small
                  v-on="on"
                  class="text-none"
                  :disabled="!currentSession?.name"
                >
                  {{ currentSession?.name || 'What does this file contain?' }}
                  <v-icon right>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-subheader>Recent Chats</v-subheader>
                <v-list-item @click="selectSession(null)">
                  <v-list-item-title class="primary--text">
                    Start New
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-for="(item, i) in sessionsList"
                  :key="i"
                  @click="selectSession(item)"
                >
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="canLoadMoreSession">
                  <v-btn
                    text
                    block
                    small
                    @click.stop="loadMoreSessions()"
                    :loading="sessionsListLoading"
                  >
                    Load more
                  </v-btn>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-spacer></v-spacer>
            <div style="min-width: 200px"></div>
          </v-card-text>
        </v-card>

        <div class="Chat__content-input">
          <v-row>
            <v-col>
              <div class="Chat__content-input-container">
                <v-row
                  class="Chat__chat"
                  id="chat_container"
                  ref="chatContainer"
                >
                  <v-col
                    v-if="!currentSessionLoading"
                    ref="chat"
                    id="chat"
                    class="pl-1 pr-1 pt-5"
                  >
                    <div
                      v-for="(item, item_index) in currentSession?.Messages ||
                      []"
                      :key="item.id"
                      class="Chat__message"
                    >
                      <div
                        class="Chat__messageContentContainer"
                        v-if="
                          !(
                            userSettings?.hideToolIO &&
                            item.type === 'tool_result'
                          )
                        "
                      >
                        <v-col>
                          <v-row
                            v-for="(content, index) in item.content || []"
                            :key="item.id + index"
                            class="Chat__message"
                          >
                            <v-col
                              v-if="! (
                                content.type ==='server_tool_use' ||
                                content.type === 'tool_search_tool_result'
                              )"
                            >
                              <v-row
                                v-if="
                                  item.role === 'assistant' &&
                                  !(
                                    userSettings?.hideToolIO &&
                                    content.type === 'tool_use'
                                  )
                                "
                                :class="'Chat__messageBot'"
                                :style="item.subSessionId ? 'border: 2px solid #1976d2; border-radius: 12px; padding: 8px; margin: 4px 0; background-color: rgba(25, 118, 210, 0.05); cursor: pointer;' : ''"
                                align-content="end"
                              >
                                <div
                                  v-if="item.subSessionId"
                                  style="
                                    font-size: 0.875rem;
                                    font-weight: 500;
                                    color: #1976d2;
                                    margin-bottom: 8px;
                                    display: flex;
                                    align-items: center;
                                  "
                                >
                                  Sub Session
                                </div>
                                <div
                                  :class="botMessageStyleMapping[content.type]"
                                >
                                  <span
                                    class="break-word"
                                    v-if="content.type === 'text'"
                                    ><div
                                      v-html="
                                        renderMarkdown(
                                          content.text?.replaceAll(
                                            paperPattern,
                                            'DOCUMENT',
                                          ),
                                        )
                                      "
                                    ></div
                                  ></span>
                                  <span v-if="content.type === 'thinking'"
                                    ><div
                                      v-html="renderMarkdown(content.thinking)"
                                    ></div
                                  ></span>
                                  <div
                                    v-if="
                                      content.type === 'tool_use' &&
                                      !isHiddenInput(content)
                                    "
                                    style="display: flex; width: 100%"
                                  >
                                    <component
                                      :is="getActionComponent(content, true)"
                                      :input="content.input"
                                      :name="content.name"
                                      :succes="true"
                                    ></component>
                                  </div>
                                </div>

                                <div
                                  class="Chat__messageToolbar"
                                  v-if="content.type === 'text'"
                                >
                                  <v-btn
                                    class="copy_btn"
                                    icon
                                    @click.stop="copy(content.text)"
                                    v-if="item?.role === 'assistant'"
                                  >
                                    <v-icon small> mdi-content-copy</v-icon>
                                  </v-btn>
                                </div>
                              </v-row>

                              <div
                                v-if="
                                  item.role === 'user' &&
                                  item.type === 'tool_result' &&
                                  JSON.stringify(item?.content)?.includes(
                                    'Error: Maximum number of tool calls reached',
                                  )
                                "
                                style="
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                  background: white;
                                  color: black;
                                  border-radius: 25px;
                                  border: 1px solid #f4f4f4;
                                  margin: 25px 50px 25px 50px;
                                  padding: 5px;
                                "
                              >
                                <span style="font-weight: bold"
                                  >Maximum number of action calls reached. Do
                                  you want to continue?</span
                                >
                              </div>

                              <v-row
                                v-if="
                                  content.type === 'tool_result' &&
                                  !JSON.stringify(content?.content)?.includes(
                                    'Error: Maximum number of tool calls reached',
                                  )
                                "
                                class="Chat__toolResultMessage"
                              >
                                <div style="width: 100%">
                                  <component
                                    :is="
                                      getActionComponent(
                                        currentSession?.Messages[
                                          item_index - 1
                                        ],
                                        false,
                                      )
                                    "
                                    :output="content.content"
                                    :name="'Action Result'"
                                    :success="true"
                                  ></component>
                                </div>
                              </v-row>

                              <v-row
                                v-if="
                                  item.role === 'user' &&
                                  !(
                                    userSettings?.hideToolIO &&
                                    content.type === 'tool_result'
                                  ) &&
                                  !JSON.stringify(item?.content)?.includes(
                                    'Error: Maximum number of tool calls reached',
                                  )
                                "
                                :class="'Chat__messageUser'"
                              >
                                <div
                                  :class="userMessageStyleMapping[content.type]"
                                >
                                  <span
                                    style="
                                      white-space: pre-line;
                                      word-break: break-word;
                                    "
                                    v-if="
                                      content.type === 'text' &&
                                      !content.text.includes('<paper>') &&
                                      !content.text.includes('<html-paper>') &&
                                      !content.text.includes('<s3-paper>')
                                    "
                                    ><div
                                      v-html="replaceLinks(content.text)"
                                    ></div
                                  ></span>
                                  <span
                                    style="white-space: pre-line"
                                    v-if="content.type === 'image'"
                                    ><v-img
                                      :width="600"
                                      style="border-radius: 15px"
                                      :src="
                                        'data:image/png;base64,' +
                                        content?.source?.data
                                      "
                                    ></v-img
                                  ></span>

                                  <chat-attached-p-d-f-document-message
                                    v-if="
                                      content.type === 'document'
                                    "
                                    :doc="content"
                                  >
                                  </chat-attached-p-d-f-document-message>
                                  <chat-attached-document-message
                                    v-if="
                                      content.type === 'text' &&
                                      content.text.includes('<paper>')
                                    "
                                    :document="content.text"
                                  >
                                  </chat-attached-document-message>
                                  <chat-attached-h-t-m-l-message
                                    v-if="
                                      content.type === 'text' &&
                                      content.text.includes('<html-paper>')
                                    "
                                    :document="content.text"
                                  >
                                  </chat-attached-h-t-m-l-message>
                                  <chat-attached-s3-message
                                    v-if="
                                      content.type === 'text' &&
                                      content.text.includes('<s3-paper>')
                                    "
                                    :document="content.text"
                                  >
                                  </chat-attached-s3-message>
                                </div>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>

                        <v-col
                          v-if="
                            item.role === 'user' &&
                            !JSON.stringify(item?.content)?.includes(
                              'tool_result',
                            )
                          "
                          class="Chat__messageIcon"
                        >
                          <component :is="`style`">
                            #avatar_{{
                              item.User?.email?.split('@')[0]
                            }}
                            {background:
                            {{
                              stringToColour(item.User?.email?.split('@')[0])
                            }};}
                          </component>
                          <div
                            :id="`avatar_${item.User?.email?.split('@')[0]}`"
                            class="Chat__userAvatar"
                          >
                            {{ item.User?.email?.slice(0, 1)?.toUpperCase() }}
                          </div>
                        </v-col>
                      </div>
                    </div>

                    <div
                      style="height: 70px; width: 70px; padding: 5px"
                      v-show="sendMessageLoading || isToolExecuting"
                    >
                      <ai-chat-loader></ai-chat-loader>
                    </div>
                    <div
                      style="height: 70px; width: 70px; padding: 5px"
                      v-show="
                        !sendMessageLoading &&
                        !isToolExecuting &&
                        currentSession?.id
                      "
                    >
                      <ai-chat-icon />
                    </div>

                    <div
                      v-if="showToolExecutionNotification"
                      class="tool-execution-notification d-flex align-center"
                      style="padding: 12px"
                    >
                      <v-icon left color="info">mdi-information</v-icon>
                      <span class="text-body-2"
                        >Your agent is off working on a task, this could take
                        longer than a minute.</span
                      >
                    </div>

                    <div ref="bottomSentinel"></div>
                  </v-col>
                  <loader v-if="currentSessionLoading"></loader>
                </v-row>

                <v-btn
                  v-if="showJumpToLatest"
                  fab
                  small
                  color="primary"
                  style="
                    position: fixed;
                    right: 24px;
                    bottom: 120px;
                    z-index: 1000;
                  "
                  @click.stop="jumpToLatest"
                >
                  <v-icon>mdi-arrow-down</v-icon>
                </v-btn>

                <component :is="`style`">
                  .Chat__chat { position: relative; }
                </component>

                <div class="Chat__messageInput">
                  <v-card
                    outlined
                    class="rounded-xxl"
                    style="padding: 15px; width: 100%"
                    @dragover.prevent
                    @drop.prevent="onFileDrop"
                  >
                    <v-textarea
                      v-model="message"
                      class="TextArea"
                      hide-details
                      no-resize
                      rows="3"
                      placeholder="Type your message here..."
                      @keydown.enter.exact.prevent="send"
                      @keydown.enter.ctrl.exact.prevent="() => {}"
                      @keydown.enter.shift.exact.prevent="() => {}"
                      id="message_input"
                    ></v-textarea>

                    <v-card-actions class="pa-2">
                      <v-file-input
                        v-model="files"
                        hide-input
                        prepend-icon="mdi-paperclip"
                        class="file-input"
                        multiple
                        accept=".doc,.docx,.pdf,.csv,.txt,.html,.odt,.rtf,.epub,.jpeg,.png,.jpg,image/*"
                        @change="onFileChange"
                      ></v-file-input>

                      <v-btn
                        icon
                        color="grey darken-1"
                        @click.stop="isSettingsOpen = true"
                      >
                        <v-icon> mdi-cog </v-icon>
                      </v-btn>

                      <v-btn
                        icon
                        @click="refreshKnowledgeBase"
                        :loading="isKnowledgeLoading"
                      >
                        <v-icon> mdi-update </v-icon>
                      </v-btn>

                      <v-spacer></v-spacer>

                      <v-btn
                        v-if="sendMessageLoading || isToolExecuting"
                        icon
                        @click.stop="stopSession"
                        color="error"
                        class="mr-2"
                      >
                        <v-icon>mdi-pause</v-icon>
                      </v-btn>

                      <v-btn
                        color="primary"
                        fab
                        small
                        @click.stop="send"
                        :loading="sendMessageLoading"
                        :disabled="
                          sendMessageLoading ||
                          isToolExecuting ||
                          !message.trim()
                        "
                      >
                        <v-icon color="white">mdi-send</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>

                  <v-row
                    v-if="
                      filesAccumulated.length !== 0 || linkPreviews.length !== 0
                    "
                    class="Chat__files"
                  >
                    <v-card outlined class="rounded-lg" width="100%">
                      <v-card-text class="pa-0">
                        <div class="filesContainer">
                          <div
                            v-for="(file, index) in filesAccumulated"
                            :key="index"
                            class="fileItem"
                          >
                            <v-card outlined>
                              <v-card-text class="pa-2 d-flex align-center">
                                <v-btn
                                  icon
                                  x-small
                                  class="mr-2"
                                  @click.stop="onFileDelete(index)"
                                >
                                  <v-icon small>mdi-close</v-icon>
                                </v-btn>

                                <v-avatar
                                  v-if="file.type.includes('image')"
                                  size="32"
                                  class="mr-2"
                                >
                                  <v-img :src="createObjectURL(file)" />
                                </v-avatar>

                                <v-avatar
                                  v-else
                                  size="32"
                                  color="primary"
                                  class="mr-2"
                                >
                                  <v-icon small color="white">mdi-file</v-icon>
                                </v-avatar>

                                <span class="text-body-2 text-truncate">{{
                                  file.name
                                }}</span>

                                <v-btn
                                  :title="
                                    filesMetadata[index]?.isPatientList
                                      ? 'Unmark'
                                      : 'Mark as patient list'
                                  "
                                  icon
                                  small
                                  class="mr-2"
                                  @click.stop="
                                    updatePatientListStatus(index, 'file')
                                  "
                                >
                                  <v-icon>{{
                                    !filesMetadata[index]?.isPatientList
                                      ? 'mdi-account-multiple-remove'
                                      : 'mdi-account-multiple-check'
                                  }}</v-icon>
                                </v-btn>
                              </v-card-text>
                            </v-card>
                          </div>

                          <div
                            v-for="(linkData, index) in linkPreviews"
                            :key="index"
                            class="fileItem"
                            @click.stop="openLink(linkData.url)"
                          >
                            <v-card outlined>
                              <v-card-text class="pa-2 d-flex align-center">
                                <v-btn
                                  icon
                                  x-small
                                  class="mr-2"
                                  @click.stop="onLinkDelete(index)"
                                >
                                  <v-icon small>mdi-close</v-icon>
                                </v-btn>

                                <v-avatar
                                  size="32"
                                  class="mr-2"
                                  v-if="linkData?.favicons?.length > 0"
                                >
                                  <v-img
                                    :src="
                                      linkData?.favicons?.length > 0
                                        ? linkData?.favicons[0]
                                        : ''
                                    "
                                  />
                                </v-avatar>

                                <div>
                                  <div>
                                    <span
                                      class="text-body-2 text-truncate"
                                      style="max-width: 250px; display: block"
                                      >{{
                                        linkData?.title || linkData.url
                                      }}</span
                                    >
                                  </div>
                                  <div>
                                    <span
                                      class="text-body-2 text-truncate"
                                      style="width: 250px; display: block"
                                      >{{ linkData?.description }}</span
                                    >
                                  </div>
                                </div>
                                <v-btn
                                  :title="
                                    linkAttachments[index].isPatientList
                                      ? 'Unmark'
                                      : 'Mark as patient list'
                                  "
                                  icon
                                  small
                                  class="mr-2"
                                  @click.stop="
                                    updatePatientListStatus(index, 'link')
                                  "
                                >
                                  <v-icon>{{
                                    !linkAttachments[index].isPatientList
                                      ? 'mdi-account-multiple-remove'
                                      : 'mdi-account-multiple-check'
                                  }}</v-icon>
                                </v-btn>
                              </v-card-text>
                            </v-card>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-row>
                </div>
              </div>
            </v-col>
            <v-col v-if="openedArtifact">
              <artifact-sidepanel></artifact-sidepanel>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <a-i-chat-settings
      :dialog="isSettingsOpen"
      @close="isSettingsOpen = false"
    />
    <edit-session-name
      :dialog="isEditSessionOpen"
      @close="isEditSessionOpen = false"
    />
  </div>
</template>

<script>
import Loader from '@/components/loader/loader.vue';
import constants from '@/util/constants';
import AIChatSettings from '@/views/ai-chat/ai-chat-settings/ai-chat-settings.vue';
import EditSessionName from '@/views/ai-chat/edit-modal/edit-session-modal.vue';
import PromptTab from '@/views/promts/tabs/prompt-tab.vue';
import SystemPromptTab from '@/views/promts/tabs/system-prompts-tab.vue';
import ToolsTab from '@/views/promts/tabs/tools-tab.vue';
import Cookies from 'js-cookie';
import cloneDeep from 'lodash/cloneDeep';
import markdownit from 'markdown-it';
import moment from 'moment';
import { io } from 'socket.io-client';
import Vue from 'vue';
import JsonViewer from 'vue-json-viewer';
import VueLoaders from 'vue-loaders';
import 'vue-loaders/dist/vue-loaders.css';
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller';
import { createNamespacedHelpers } from 'vuex';

import GoogleGetFolderInput from '../ai-workspaces/workspace/general-actions/action-ui/google/get-folder/google-get-folder-input.vue';
import GoogleGetFolderOutput from '../ai-workspaces/workspace/general-actions/action-ui/google/get-folder/google-get-folder-output.vue';
import GoogleSearchInput from '../ai-workspaces/workspace/general-actions/action-ui/google/search/google-search-input.vue';
import GoogleSearchOutput from '../ai-workspaces/workspace/general-actions/action-ui/google/search/google-search-output.vue';

import S3DownloadInput from '../ai-workspaces/workspace/general-actions/action-ui/aws/s3-download/s3-download-input.vue';
import S3DownloadOutput from '../ai-workspaces/workspace/general-actions/action-ui/aws/s3-download/s3-downoad-output.vue';
import S3UploadInput from '../ai-workspaces/workspace/general-actions/action-ui/aws/s3-upload/s3-upload-input.vue';
import S3UploadOutput from '../ai-workspaces/workspace/general-actions/action-ui/aws/s3-upload/s3-upload-output.vue';
import SesSendEmailInput from '../ai-workspaces/workspace/general-actions/action-ui/aws/send-email/ses-send-email-input.vue';
import SesSendEmailOutput from '../ai-workspaces/workspace/general-actions/action-ui/aws/send-email/ses-send-email-output.vue';

import ArtifactSidepanel from '@/views/ai-chat/artifact-sidepanel/artifact-sidepanel.vue';
import ChatAttachedDocumentMessage from '@/views/ai-chat/components/chat-attached-document.vue';
import ChatAttachedHTMLMessage from '@/views/ai-chat/components/chat-attached-html.vue';
import ChatAttachedS3Message from '@/views/ai-chat/components/chat-attached-s3-file.vue';
import AiChatIcon from '@/views/ai-chat/components/loader/ai-chat-icon.vue';
import AiChatLoader from '@/views/ai-chat/components/loader/ai-chat-loader.vue';
import CreateAgentArtifactOutput from '@/views/ai-workspaces/workspace/general-actions/action-ui/artifacts/create-agent-artifact-output.vue';
import GoogleSearchInDriveInput from '@/views/ai-workspaces/workspace/general-actions/action-ui/google/search-in-drive/google-search-in-drive-input.vue';
import GoogleSearchInDriveOutput from '@/views/ai-workspaces/workspace/general-actions/action-ui/google/search-in-drive/google-search-in-drive-output.vue';
import GetSkillOutput from '@/views/ai-workspaces/workspace/general-actions/action-ui/skills/get-skill-output.vue';
import DefaultActionInput from '../ai-workspaces/workspace/general-actions/action-ui/default/default-action-input.vue';
import DefaultActionOutput from '../ai-workspaces/workspace/general-actions/action-ui/default/default-action-output.vue';
import KnowledgeBaseActionInput from '../ai-workspaces/workspace/general-actions/action-ui/knowledge-base/knowledge-base-action-input.vue';
import KnowledgeBaseActionOutput from '../ai-workspaces/workspace/general-actions/action-ui/knowledge-base/knowledge-base-action-output.vue';
import OneDriveCreateFolderActionInput from '../ai-workspaces/workspace/general-actions/action-ui/onedrive/create-folder/one-drive-create-folder-action-input.vue';
import OneDriveCreateFolderActionOutput from '../ai-workspaces/workspace/general-actions/action-ui/onedrive/create-folder/one-drive-create-folder-action-output.vue';
import OneDriveDownloadActionInput from '../ai-workspaces/workspace/general-actions/action-ui/onedrive/download/one-drive-download-action-input.vue';
import OneDriveDownloadActionOutput from '../ai-workspaces/workspace/general-actions/action-ui/onedrive/download/one-drive-download-action-output.vue';
import OneDriveFileAccessActionInput from '../ai-workspaces/workspace/general-actions/action-ui/onedrive/file-access/one-drive-file-access-action-input.vue';
import OneDriveFileAccessActionOutput from '../ai-workspaces/workspace/general-actions/action-ui/onedrive/file-access/one-drive-file-access-action-output.vue';
import OneDriveListFolderActionInput from '../ai-workspaces/workspace/general-actions/action-ui/onedrive/list-folder/one-drive-list-folder-action-input.vue';
import OneDriveListFolderActionOutput from '../ai-workspaces/workspace/general-actions/action-ui/onedrive/list-folder/one-drive-list-folder-action-output.vue';
import OneDriveUploadActionInput from '../ai-workspaces/workspace/general-actions/action-ui/onedrive/upload/one-drive-upload-action-input.vue';
import OneDriveUploadActionOutput from '../ai-workspaces/workspace/general-actions/action-ui/onedrive/upload/one-drive-upload-action-output.vue';
import BatchGetPatientBenefitsActionInput from '../ai-workspaces/workspace/general-actions/action-ui/pverify/batch-get-patient-benefits/batch-get-patient-benefits-action-input.vue';
import BatchGetPatientBenefitsActionOutput from '../ai-workspaces/workspace/general-actions/action-ui/pverify/batch-get-patient-benefits/batch-get-patient-benefits-action-output.vue';
import GetPatientBenefitsActionInput from '../ai-workspaces/workspace/general-actions/action-ui/pverify/get-patient-benefits/get-patient-benefits-action-input.vue';
import GetPatientBenefitsActionOutput from '../ai-workspaces/workspace/general-actions/action-ui/pverify/get-patient-benefits/get-patient-benefits-action-output.vue';
import TalkToAgentActionInput from '../ai-workspaces/workspace/general-actions/action-ui/talk-to-agent/talk-to-agent-action-input.vue';
import TalkToAgentActionOutput from '../ai-workspaces/workspace/general-actions/action-ui/talk-to-agent/talk-to-agent-action-output.vue';
import TwilioListSMSInput from '../ai-workspaces/workspace/general-actions/action-ui/twilio/list-sms/twilio-list-sms-input.vue';
import TwilioListSMSOutput from '../ai-workspaces/workspace/general-actions/action-ui/twilio/list-sms/twilio-list-sms-output.vue';
import TwilioSendEmailInput from '../ai-workspaces/workspace/general-actions/action-ui/twilio/send-email/twilio-send-email-input.vue';
import TwilioSendEmailOutput from '../ai-workspaces/workspace/general-actions/action-ui/twilio/send-email/twilio-send-email-output.vue';
import TwilioSendSMSInput from '../ai-workspaces/workspace/general-actions/action-ui/twilio/send-sms/twilio-send-sms-input.vue';
import TwilioSendSMSOutput from '../ai-workspaces/workspace/general-actions/action-ui/twilio/send-sms/twilio-send-sms-output.vue';
import ChatAttachedPDFDocumentMessage from '@/views/ai-chat/components/chat-attached-pdf-document.vue';

const {
  mapGetters: AIChatGetters,
  mapActions: AIChatActions,
  mapMutations: AIChatMutations,
} = createNamespacedHelpers('AIChat');
const { mapGetters: customerGetters } = createNamespacedHelpers('customer');
const { mapGetters: workspacesGetters, mapActions: workspaceActions } =
  createNamespacedHelpers('aiWorkspace');

const { mapActions: sharedActions } = createNamespacedHelpers('shared');

Vue.component('DynamicScroller', DynamicScroller);
Vue.component('DynamicScrollerItem', DynamicScrollerItem);
Vue.use(VueLoaders);

export default {
  name: 'AIChat',
  components: {
    ChatAttachedPDFDocumentMessage,
    ArtifactSidepanel,
    AiChatIcon,
    AiChatLoader,
    ChatAttachedS3Message,
    ChatAttachedHTMLMessage,
    ChatAttachedDocumentMessage,
    Loader,
    ToolsTab,
    SystemPromptTab,
    PromptTab,
    EditSessionName,
    AIChatSettings,
    JsonViewer,
    GoogleSearchInput,
    GoogleSearchOutput,
    DefaultActionOutput,
    DefaultActionInput,
    OneDriveDownloadActionInput,
    OneDriveDownloadActionOutput,
    OneDriveFileAccessActionOutput,
    OneDriveFileAccessActionInput,
    OneDriveUploadActionInput,
    OneDriveUploadActionOutput,
    OneDriveListFolderActionInput,
    OneDriveListFolderActionOutput,
    OneDriveCreateFolderActionOutput,
    OneDriveCreateFolderActionInput,
    TalkToAgentActionOutput,
    TalkToAgentActionInput,
    TwilioListSMSInput,
    TwilioListSMSOutput,
    TwilioSendSMSInput,
    TwilioSendSMSOutput,
    TwilioSendEmailInput,
    TwilioSendEmailOutput,
    GetPatientBenefitsActionOutput,
    GetPatientBenefitsActionInput,
    BatchGetPatientBenefitsActionInput,
    BatchGetPatientBenefitsActionOutput,
    GoogleGetFolderInput,
    GoogleGetFolderOutput,
    GoogleSearchInDriveInput,
    GoogleSearchInDriveOutput,
    SesSendEmailInput,
    SesSendEmailOutput,
    S3UploadInput,
    S3UploadOutput,
    S3DownloadInput,
    S3DownloadOutput,
    CreateAgentArtifactOutput,
    GetSkillOutput,
  },
  data() {
    return {
      memoryModalKey: 'memory_key',
      AI_CHAT_WEBSOCKET_URL: 'https://dev.shifthealth.io/ws/ai_service',
      IS_LOCAL_HOST: 'false',
      publicPath: constants.isDevelopment ? '' : '',
      editSession: null,
      isEditSessionOpen: false,
      isMemoryEditOpen: false,
      socket: undefined,
      paperPattern: /<paper>(.*?)<\/paper>/gs,
      files: [],
      filesAccumulated: [],
      filesMetadata: [],
      sessionPage: 0,
      messageCheckingTimer: null,
      message: '',
      isSettingsOpen: false,
      canLoadMoreSession: true,
      userMessageStyleMapping: {
        text: 'Chat__messageContentUser',
        image: 'Chat__imageMessage',
        tool_result: 'Chat__toolResultMessage',
      },
      botMessageStyleMapping: {
        text: 'Chat__messageContentBot',
        thinking: 'Chat__thinkingContent',
        tool_use: 'Chat__toolUseMessage',
      },
      linkPreviews: [],
      linkAttachments: [],
      autoFollow: true,
      isAtBottom: true,
      showJumpToLatest: false,
      toolExecuting: false,
      showToolExecutionNotification: false,
      toolExecutionTimer: null,
    };
  },
  watch: {
    async 'selectedCustomer.customer_id'() {
      this.getSessions({ page: this.sessionPage, push: false });
      this.setSession(null);
      this.setChatWorkspace(null);
      this.$router.push({ query: {} });
    },
  },
  computed: {
    ...AIChatGetters({
      sessionsList: 'SESSIONS_LIST',
      sessionsListLoading: 'SESSIONS_LIST_LOADING',
      toolSets: 'TOOL_SETS',
      toolSetsLoading: 'TOOL_SETS_LOADING',
      createToolSetLoading: 'CREATE_TOOL_SET_LOADING',
      currentToolSet: 'CURRENT_TOOL_SETS',
      currentToolSetLoading: 'CURRENT_TOOL_SET_LOADING',
      AIResponseLoading: 'AI_RESPONSE_LOADING',
      currentSession: 'CURRENT_SESSION',
      currentSessionLoading: 'CURRENT_SESSION_LOADING',
      userSettings: 'USER_SETTINGS',
      userSettingsLoading: 'USER_SETTINGS_LOADING',
      sendMessageLoading: 'SEND_MESSAGE_LOADING',
      sendMessageData: 'GET_SEND_MESSAGE_DATA',
      chatWorkspace: 'GET_CHAT_WORKSPACE',
      openedArtifact: 'GET_CHAT_ARTIFACT',
    }),
    ...customerGetters({
      user: 'USER',
      selectedCustomer: 'SELECTED_CUSTOMER',
    }),
    ...workspacesGetters({
      workspaces: 'WORKSPACES_LIST',
      workspacesLoading: 'WORKSPACE_LIST_LOADING',
      isKnowledgeLoading: 'WORKSPACE_KNOWLEDGE_FILES_LOADING',
    }),
    isToolExecuting() {
      return this.toolExecuting;
    },
  },
  methods: {
    ...sharedActions(['getLinkPreview']),
    cloneDeep,
    ...AIChatActions([
      'createToolSet',
      'getCurrentSession',
      'getSessions',
      'getToolSets',
      'getUserSettings',
      'sendMessage',
      'getToolSets',
      'updateUserSettings',
      'getLastMessage',
      'updateSession',
      'hardStopSession',
    ]),
    ...workspaceActions([
      'getWorkspaces',
      'getWorkspace',
      'refreshAdvancedWorkspaceKnowledge',
    ]),
    ...AIChatMutations({
      setSession: 'SET_CURRENT_SESSION',
      setSendMessageLoading: 'SET_SEND_MESSAGE_LOADING',
      setEditSession: 'SET_EDIT_SESSION',
      setSendMessage: 'SET_SEND_MESSAGE',
      setChatWorkspace: 'SET_CHAT_WORKSPACE',
      setSessionList: 'SET_SESSIONS_LIST',
      addMessageToCurrentSession: 'ADD_MESSAGE_TO_CURRENT_SESSION',
      updateMessageInCurrentSession: 'UPDATE_MESSAGE_IN_CURRENT_SESSION',
      addContentToCurrentSessionMessage:
        'ADD_CONTENT_TO_CURRENT_SESSION_MESSAGE',
      updateCurrentSessionMessageContent:
        'UPDATE_CURRENT_SESSION_MESSAGE_CONTENT',
    }),
    updatePatientListStatus(index, type) {
      if (type === 'link') {
        this.linkAttachments[index].isPatientList =
          !this.linkAttachments[index]?.isPatientList;
      }
      if (type === 'file') {
        this.filesMetadata[index].isPatientList =
          !this.filesMetadata[index]?.isPatientList;
      }
    },
    updateFileVisualMode(index, type) {
      if (type === 'file') {
        this.filesMetadata[index].isVisualMode =
          !this.filesMetadata[index]?.isVisualMode;
      }
    },
    openLink(url) {
      window.open(url, '_blank');
    },
    renderMarkdown(text) {
      const md = markdownit({
        breaks: true,
        linkify: true,
      });
      return md.render(text);
    },
    replacer(matched) {
      let withProtocol = matched;

      if (!withProtocol.startsWith('http')) {
        withProtocol = 'http://' + matched;
      }

      const newStr = `<a class="text-link" href="${withProtocol}" target="_blank" rel="noopener noreferrer">${matched}</a>`;

      return newStr;
    },
    replaceLinks(text) {
      const linkRegex = /(https?:\/\/)?(www\.)?[^\s]+\.[^\s]+/g;
      return text.replaceAll(linkRegex, this.replacer);
    },
    isHiddenInput(action) {
      const hiddenInputActions = [
        'internal_get_skill_action',
        'ai_create_agent_artifact',
      ];
      return hiddenInputActions.includes(action?.name);
    },
    getActionComponent(action, isInput) {
      if (!isInput) {
        action = action.content.find((act) => act.type === 'tool_use');
      }
      if (action?.name?.includes('msgraph_file_access')) {
        if (isInput) {
          return OneDriveFileAccessActionInput;
        }
        return OneDriveFileAccessActionOutput;
      }
      if (action?.name?.includes('gen_ai_prompt_')) {
        if (isInput) {
          return TalkToAgentActionInput;
        }
        return TalkToAgentActionOutput;
      }
      switch (action?.name) {
        case 'aws_s3_upload':
          if (isInput) {
            return S3UploadInput;
          }
          return S3UploadOutput;
        case 'aws_s3_download':
          if (isInput) {
            return S3DownloadInput;
          }
          return S3DownloadOutput;
        case 'aws_ses_send_email':
          if (isInput) {
            return SesSendEmailInput;
          }
          return SesSendEmailOutput;
        case 'google_search':
          if (isInput) {
            return GoogleSearchInput;
          }
          return GoogleSearchOutput;
        case 'google_get_folder':
          if (isInput) {
            return GoogleGetFolderInput;
          }
          return GoogleGetFolderOutput;
        case 'google_search_in_drive':
          if (isInput) {
            return GoogleSearchInDriveInput;
          }
          return GoogleSearchInDriveOutput;
        case 'internal_knowledge_action':
          if (isInput) {
            return KnowledgeBaseActionInput;
          }
          return KnowledgeBaseActionOutput;
        case 'internal_get_skill_action':
          return GetSkillOutput;
        case 'twilio_list_sms':
          if (isInput) {
            return TwilioListSMSInput;
          }
          return TwilioListSMSOutput;
        case 'twilio_send_sms':
          if (isInput) {
            return TwilioSendSMSInput;
          }
          return TwilioSendSMSOutput;
        case 'twilio_send_email':
          if (isInput) {
            return TwilioSendEmailInput;
          }
          return TwilioSendEmailOutput;
        case 'msgraph_onedrive_download_file':
          if (isInput) {
            return OneDriveDownloadActionInput;
          }
          return OneDriveDownloadActionOutput;
        case 'msgraph_onedrive_upload_file':
          if (isInput) {
            return OneDriveUploadActionInput;
          }
          return OneDriveUploadActionOutput;
        case 'msgraph_onedrive_get_folder':
          if (isInput) {
            return OneDriveListFolderActionInput;
          }
          return OneDriveListFolderActionOutput;
        case 'msgraph_onedrive_create_folder':
          if (isInput) {
            return OneDriveCreateFolderActionInput;
          }
          return OneDriveCreateFolderActionOutput;
        case 'get_benefits_pverify':
          if (isInput) {
            return GetPatientBenefitsActionInput;
          }
          return GetPatientBenefitsActionOutput;
        case 'get_benefits_batch_pverify_from_file':
        case 'get_benefits_batch_pverify':
          if (isInput) {
            return BatchGetPatientBenefitsActionInput;
          }
          return BatchGetPatientBenefitsActionOutput;
        case 'ai_create_agent_artifact':
          return CreateAgentArtifactOutput;
        default:
          if (isInput) {
            return DefaultActionInput;
          }
          return DefaultActionOutput;
      }
    },
    getMemory() {
      if (typeof this.currentSession?.memory === 'string') {
        return JSON.parse(cloneDeep(this.currentSession?.memory));
      }
      return cloneDeep(this.currentSession?.memory) || {};
    },
    createObjectURL(file) {
      return URL.createObjectURL(file);
    },
    async updateCurrentSession(data) {
      await this.updateSession({ ...data, sessionId: this.currentSession?.id });
      this.memoryModalKey = 'memory_key' + Math.random();
    },
    async changeWorkspace(workspace) {
      this.setSendMessageLoading(false);
      this.setChatWorkspace(workspace);
      this.setSession(null);
    },
    validateSize(input) {
      const fileSize = input.size / 1024 / 1024; // in MiB
      return fileSize > 1;
    },
    stringToColour(str) {
      if (!str) {
        str = '';
      }
      let hash = 0;
      str.split('').forEach((char) => {
        hash = char.charCodeAt(0) + ((hash << 5) - hash);
      });
      let colour = '#';
      for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xff;
        colour += value.toString(16).padStart(2, '0');
      }
      return colour;
    },
    async copy(text) {
      await navigator.clipboard.writeText(text);
    },
    isJSONString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    async loadMoreSessions() {
      this.sessionPage += 1;
      const preLoadCount = this.sessionsList.length;
      await this.getSessions({ page: this.sessionPage, push: true });
      const postLoad = this.sessionsList.length;
      if (postLoad === preLoadCount) {
        this.canLoadMoreSession = false;
      }
    },
    async selectSession(session) {
      if (this.currentSession?.id === session?.id) {
        return;
      }
      this.setSendMessageLoading(false);

      if (!session) {
        this.setSession(null);
        return;
      }
      await this.getCurrentSession({ sessionId: session?.id });
      console.log('SET SESSION', session?.id)
      console.log('SET CURRENT SESSION', this.currentSession.id)
      this.$router.push({ query: { session: this.currentSession.id } });
      this.scroll();
    },
    makeDisplayMessage(files) {
      const init = {
        id: Math.random(),
        content: [
          {
            text: this.message,
            type: 'text',
          },
        ],
        role: 'user',
        type: 'common',
        User: {
          email: this?.user?.email,
        },
      };
      for (const file of files) {
        if (file.type.includes('image/')) {
          init.content.push({
            type: 'image',
            source: {
              type: 'base64',
              data: file.base64.replace(/^data:image\/\w+;base64,/, ''),
            },
          });
        } else if(file.type.includes('pdf')) {
          init.content.push({
            type: 'document',
            title: file.name,
            source: {
              type: 'base64',
              data: file.base64.replace('data:application/pdf;base64,', ''),
              media_type: 'application/pdf'
            },
          });
        } else {
          init.content.push({
            text: `${file.name}`,
            type: 'text',
          });
        }
      }
      return init;
    },
    async stopSession() {
      await this.hardStopSession({ sessionId: this.currentSession.id });
    },
    async send(memory, fromAnotherPage = false) {
      if (
        (this.sendMessageLoading && !fromAnotherPage) ||
        this.isToolExecuting
      ) {
        return;
      }
      if (this.message === '') {
        return;
      }
      const files = await this.prepareFiles();
      const displayMessage = this.makeDisplayMessage(files);
      if (!this.currentSession.id) {
        this.setSession({
          Messages: [displayMessage],
        });
      } else {
        this.addMessageToCurrentSession(displayMessage);
      }

      const messageValue = this.message.valueOf();
      this.message = '';
      this.setSendMessageLoading(true);

      this.filesAccumulated = [];
      this.filesMetadata = [];
      this.files = [];

      const linkAttachmentsData = cloneDeep(this.linkAttachments);
      this.linkAttachments = [];
      this.linkPreviews = [];

      this.scroll();

      const workspaceId = this.currentSession?.workspaceId ||
          this.sendMessageData?.workspaceId ||
          this?.chatWorkspace?.id;

      const { session, answer } = await this.sendMessage({
        sessionId: this.currentSession.id,
        workspaceId: workspaceId,
        files: files,
        linkAttachments: linkAttachmentsData,
        content: [
          {
            text: messageValue,
            type: 'text',
          },
        ],
        memory: memory,
      });

      if (workspaceId) {
        localStorage.setItem('lastUsedAgentId', workspaceId.toString());
      }

      if (!this.currentSession?.id) {
        const sessionList = cloneDeep(this.sessionsList);
        sessionList.pop();
        sessionList.unshift(session);
        this.setSessionList(sessionList);
        this.$router.push({ query: { session: session.id } });
      }

      if (answer.type === 'error') {
        this.setSendMessageLoading(false);
        this.toolExecuting = false;
        this.clearToolExecutionTimer();
      }

      if (!this.currentSession.id) {
        this.setSession(session);
      } else {
        const sessionCopy = this.currentSession;
        const messageLength = session.Messages?.length;
        const lastIndex = messageLength > 0 ? messageLength - 1 : 0;
        sessionCopy.Messages[lastIndex] = answer;
        this.setSession(sessionCopy);
      }
      this.scroll();
    },
    formatDate(date) {
      if (!date) return '';
      return moment(date).format(`HH:MM:SS, DD MMMM YYYY`);
    },
    onFileChange(event) {
      event.forEach((thisFile) => {
        if (this.validateSize(thisFile)) {
          this.$store.dispatch(
            'notifications/setError',
            `${thisFile.name} too big`,
          );
          return;
        }
        this.filesAccumulated.push(thisFile);

        this.filesMetadata.push({ isPatientList: false, isVisualMode: false });
      });
      this.files = [];
    },
    scroll() {
      if (!this.autoFollow) return;
      this.scrollToBottom(true);
    },
    onFileDelete(index) {
      this.filesAccumulated.splice(index, 1);
      this.filesMetadata.splice(index, 1);
      this.files = [];
    },
    onLinkDelete(index) {
      this.linkAttachments.splice(index, 1);
      this.linkPreviews.splice(index, 1);
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
      });
    },
    async prepareFiles() {
      const prepared = await Promise.all(
        this.filesAccumulated.map(async (file, index) => {
          const base64 = await this.toBase64(file);
          return {
            base64: base64,
            name: file.name,
            type: file.type,
            isPatientList: this.filesMetadata[index]?.isPatientList,
            isVisualMode: this.filesMetadata[index]?.isVisualMode,
          };
        }),
      );
      return prepared;
    },
    connectSocket() {
      const path =
        this.IS_LOCAL_HOST === 'true'
          ? {}
          : { path: '/ws/ai_service/socket.io' };
      this.socket = io(this.AI_CHAT_WEBSOCKET_URL, {
        auth: {
          userId: Cookies.get('userId'),
        },
        ...path,
      });

      this.socket.on('chat:message_chunk', this.processMessageChunk);
    },
    goToWorkspace(item) {
      this.$router.push({ path: `/agents/${item.id}` });
    },
    goToStartPage() {
      this.$router.push({ path: `/start-chat` });
    },
    processMessageChunk({ chunk_type, chunk, message, messageType, subSessionId }) {
      const lastIndex = this.currentSession.Messages.length - 1;
      if (chunk_type === 'stream_finished') {
        if(!subSessionId) {
          this.setSendMessageLoading(false);
        }
        const messageContent = this.currentSession.Messages[lastIndex];
        if (!messageContent.type === 'tool_user') {
          if(!subSessionId) {
            this.toolExecuting = false;
          }
          this.toolExecuting = false;
          this.clearToolExecutionTimer();
        }
        this.scroll();
        return;
      }
      if (chunk_type === 'new_message') {
        const newMessage = message
          ? message
          : {
              id: Math.random(),
              content: [],
              role: 'assistant',
              type: 'common',
              subSessionId,
            };
        if (
          newMessage.type === 'error' ||
          JSON.stringify(message?.content)?.includes(
            'Error: Maximum number of tool calls reached',
          )
        ) {
          if(!subSessionId) {
            this.setSendMessageLoading(false);
          }
        } else {
          this.setSendMessageLoading(true);
        }
        this.toolExecuting = messageType === 'tool_user';
        if (this.toolExecuting) {
          this.startToolExecutionTimer();
        } else {
          this.clearToolExecutionTimer();
        }
        this.addMessageToCurrentSession(newMessage);
        return;
      }
      if (chunk_type === 'content_block_start') {
        let message = chunk.content_block;
        if (message.type === 'tool_use') {
          message.input = '';
          this.toolExecuting = true;
          this.startToolExecutionTimer();
        }
        this.addContentToCurrentSessionMessage({
          messageIndex: lastIndex,
          content: message,
        });
      }

      if (chunk_type === 'content_block_delta') {
        const messageContent = this.currentSession.Messages[lastIndex];
        const content = cloneDeep(messageContent.content[chunk.index]);

        switch (chunk.delta.type) {
          case 'input_json_delta':
            content.input +=
              typeof chunk.delta.partial_json === 'object'
                ? JSON.stringify(chunk.delta.partial_json)
                : chunk.delta.partial_json;
            break;

          case 'text_delta':
            content.text += chunk.delta.text;
            break;

          case 'thinking_delta':
            content.thinking += chunk.delta.thinking;
            break;

          default:
            console.warn('Unknown delta type:', chunk.delta.type);
        }

        this.updateCurrentSessionMessageContent({
          messageIndex: lastIndex,
          chunkIndex: chunk.index,
          content,
        });
      }

      this.updateMessageInCurrentSession({
        messageIndex: lastIndex,
        content: {
          ...this.currentSession.Messages[lastIndex],
          type: messageType,
        },
      });
      this.toolExecuting = messageType === 'tool_user';
      if (this.toolExecuting) {
        this.startToolExecutionTimer();
      } else {
        this.clearToolExecutionTimer();
      }
      this.scroll();
    },
    onFileDrop(e) {
      if (!e.dataTransfer || !e.dataTransfer.files) return;
      const droppedFiles = Array.from(e.dataTransfer.files);
      if (droppedFiles.length === 0) return;
      this.onFileChange(droppedFiles);
    },
    scrollToBottom(smooth = true) {
      requestAnimationFrame(() => {
        this.$refs.bottomSentinel?.scrollIntoView({
          behavior: smooth ? 'smooth' : 'instant',
        });
      });
    },
    jumpToLatest() {
      this.autoFollow = true;
      requestAnimationFrame(() => {
        this.scrollToBottom(true);
      });
    },
    refreshKnowledgeBase() {
      const workspaceId =
        this.currentSession?.workspaceId || this?.chatWorkspace?.id;
      this.refreshAdvancedWorkspaceKnowledge({ workspaceId: workspaceId });
    },
    startToolExecutionTimer() {
      this.clearToolExecutionTimer();

      this.toolExecutionTimer = setTimeout(() => {
        if (this.isToolExecuting) {
          this.showToolExecutionNotification = true;
        }
      }, 10000);
    },
    clearToolExecutionTimer() {
      if (this.toolExecutionTimer) {
        clearTimeout(this.toolExecutionTimer);
        this.toolExecutionTimer = null;
      }
      this.showToolExecutionNotification = false;
    },
  },
  async created() {
    this.AI_CHAT_WEBSOCKET_URL = process.env.VUE_APP_AI_CHAT_WEBSOCKET_URL;
    this.IS_LOCAL_HOST = process.env.VUE_APP_AI_CHAT_IS_LOCALHOST;
    this.connectSocket();
    this.setSession(null);

    await this.getUserSettings();

    this.getSessions({ page: this.sessionPage, push: false });
    this.getWorkspaces();

    if (this.$route.query.session) {
      await this.getCurrentSession({ sessionId: this.$route.query.session });
    }

    this.scroll();

    if (this.sendMessageData) {
      this.filesAccumulated = this.sendMessageData.files;
      this.filesMetadata = this.sendMessageData.filesMetadata;
      this.linkAttachments = this.sendMessageData.linkAttachments;
      this.message = this.sendMessageData.messageValue;
      await this.send(this.sendMessageData.memory, true);
      this.setSendMessage(null);
    }

    const lastIndex = (this.currentSession?.Messages?.length || 1) - 1;
    let messageType;
    try {
      messageType = this.currentSession?.Messages[lastIndex]?.type;
    } catch (e) {
      console.log(e);
    }
    if (messageType === 'error' || !messageType) {
      this.setSendMessageLoading(false);
    }
    if (messageType === 'tool_user') {
      this.toolExecuting = true;
      this.startToolExecutionTimer();
    }
  },
  beforeDestroy() {
    this.socket?.disconnect();
    this.clearToolExecutionTimer();
  },
  mounted() {
    const el = this.$refs.chatContainer;
    const sentinel = this.$refs.bottomSentinel;

    const io = new IntersectionObserver(
      ([entry]) => {
        this.isAtBottom = entry.isIntersecting;
        this.autoFollow = entry.isIntersecting;
        this.showJumpToLatest = !entry.isIntersecting;
      },
      { root: el, threshold: 0 },
    );
    io.observe(sentinel);

    el.addEventListener(
      'scroll',
      () => {
        const nearBottom =
          el.scrollHeight - (el.scrollTop + el.clientHeight) < 120;
        this.isAtBottom = nearBottom;
        this.showJumpToLatest = !nearBottom;
        this.autoFollow = nearBottom;
      },
      { passive: true },
    );

    document
      .getElementById('message_input')
      .addEventListener('keydown', async (e) => {
        const getCaret = (el) => {
          if (el.selectionStart) {
            return el.selectionStart;
          } else if (document.selection) {
            el.focus();
            const r = document.selection.createRange();
            if (r == null) {
              return 0;
            }
            const re = el.createTextRange(),
              rc = re.duplicate();
            re.moveToBookmark(r.getBookmark());
            rc.setEndPoint('EndToStart', re);
            return rc.text.length;
          }
          return 0;
        };

        const start = e.target.selectionStart;
        const end = e.target.selectionEnd;
        const caret = getCaret(e.target);
        if (
          e.key == 'Enter' &&
          e.ctrlKey == false &&
          e.shiftKey == false &&
          this.message.replaceAll('\n', '') !== ''
        ) {
          //await this.send();
        }
        if (e.key == 'Enter' && e.ctrlKey == true) {
          this.message =
            this.message.substring(0, caret) +
            '\n' +
            this.message.substring(end);
          e.stopPropagation();
          setTimeout(() => {
            e.target.selectionStart = e.target.selectionEnd = start + 1;
          }, 1);
        }
        if (e.key == 'Enter' && e.shiftKey == true) {
          this.message =
            this.message.substring(0, caret) +
            '\n' +
            this.message.substring(end);
          e.stopPropagation();
          setTimeout(() => {
            e.target.selectionStart = e.target.selectionEnd = start + 1;
          }, 1);
        }
      });
    document.getElementById('message_input').onpaste = async (event) => {
      const items = (
        event?.clipboardData || event?.originalEvent?.clipboardData
      ).items;
      for (const index in items) {
        const item = items[index];
        if (item.kind === 'file') {
          const blob = item.getAsFile();
          this.filesAccumulated ??= [];
          this.filesAccumulated.push(blob);
          continue;
        }

        let pastedText = '';
        if (window.clipboardData && window.clipboardData.getData) {
          // IE
          pastedText = window.clipboardData.getData('Text');
        } else if (event.clipboardData && event.clipboardData.getData) {
          pastedText = event.clipboardData.getData('text/plain');
        }
        // eslint-disable-next-line
        const linkRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/
        if (linkRegex.test(pastedText)) {
          const preview = await this.getLinkPreview(pastedText);
          this.linkPreviews.push(preview);
          this.linkAttachments.push({
            url: pastedText,
            isPatientList: false,
            isVisualMode: false,
          });
        }
      }
    };
  },
};
</script>

<style lang="scss">
@import './ai-chat';
</style>
